import hdrm from '../../hdrm';
import site from '../../site';
import globals from '../../globals';

import actionTypes from '../constants/action-types';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

const handleSetInlineStyleAction = (action) => {
  const { elementId, propertyName, value, options } = action.payload;
  const { strategy } = options;

  return hdrm.operations.setInlineElementStyle(elementId, propertyName, value, strategy);
};

const setInlineElementStyle = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        (targetAction) => targetAction.type === actionTypes.SET_INLINE_ELEMENT_STYLE
      );

      actions.forEach((targetAction) => {
        handleSetInlineStyleAction(targetAction);
      });

      next(action);

      break;
    }
    case actionTypes.SET_INLINE_ELEMENT_STYLE: {
      const { globalsToUpdate, options } = action.payload;
      const { strategy } = options;

      const newHTML = handleSetInlineStyleAction(action);

      if (strategy !== UPDATE_LIVE_ONLY) {
        const state = store.getState();
        const pageId = site.selectors.getActivePageId(state);

        globals.helpers.saveGlobals(globalsToUpdate);
        store.dispatch(site.actions.setPageHTML(pageId, newHTML));
      }

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default setInlineElementStyle;
